import {getProjectId} from 'common/report/util';
import {ModelResource} from 'common/util/model-resource/model-resource';
import {StorageManager} from 'common/contexts/storage-manager/types';

import {LocalStorageKey} from '../constants';
import {UserLocalStorageHelper} from '../user-local-storage';
import {userCookieUtils} from '../util/user-identity-from-cookie';

export class GlobalSearchController extends ModelResource {
  sessionStorageManager: StorageManager;
  persistedStateStorage: UserLocalStorageHelper<string>;
  constructor({sessionStorageManager}: {sessionStorageManager: StorageManager}) {
    super();
    this.sessionStorageManager = sessionStorageManager;

    this.persistedStateStorage = new UserLocalStorageHelper({
      namespace: LocalStorageKey.SearchedTextPersistedState,
      context: sessionStorageManager,
    });
  }

  async setSearchedText(searchedText: string) {
    const userId = userCookieUtils.getUserIdentityFromCookie()?.id;
    const projectId = getProjectId();

    await this.persistedStateStorage.setItem({userId, key: projectId, value: searchedText});
    this.notifySubscribers();
  }

  getSearchedText(): string {
    const userId = userCookieUtils.getUserIdentityFromCookie()?.id;
    const projectId = getProjectId();
    return this.persistedStateStorage.getItem({userId, key: projectId}) ?? ``;
  }
}
